// Batch processing constants
export const BATCH_SIZE = 50
export const MAX_CONCURRENT_REQUESTS = 3
export const BATCH_DELAY_MS = 500

// PHI box styling constants
export const PHI_BOX_COLOR = '#5acce6'
export const PHI_BOX_FILL = 'rgba(90, 204, 230, 0.2)'

// Cornerstone configuration
export const CORNERSTONE_CONFIG = {
  renderingEngineId: 'dicomRenderingEngine',
  viewportId: 'STACK_VIEWPORT',
  toolGroupId: 'STACK_TOOL_GROUP_ID',
  maxWebWorkers: 4,
  cacheSize: 3 * 1024 * 1024 * 1024, // 3GB
  stackScrollDelta: 0.25, // 25% of default speed
}

// UI constants
export const VIEWPORT_CONFIG = {
  height: '70vh',
  minHeight: '400px',
  maxHeight: '800px',
}

// Drawing constants
export const DRAWING_CONFIG = {
  minBoxSize: 5,
  handleSize: 8,
  gridPattern: {
    width: 20,
    height: 20,
    strokeWidth: 0.5,
  },
}

// Polling intervals
export const POLLING_INTERVALS = {
  phiStatus: 5000, // 5 seconds
  resizeDelay: 150,
  renderDelay: 50,
  redrawDelay: 100,
}
